import { dataFor } from '../data';
import { useLanguage } from './use-content';

export interface ScreeningImageData {
  internalName?: string;
  image: { url: string; title?: string; description?: string };
  description?: string;
  header?: string;
}

export interface UseScreeningImageResult {
  data?: ScreeningImageData;
  isLoading: boolean;
}

export function useScreeningImage(id?: string): UseScreeningImageResult {
  const language = useLanguage();
  const images = dataFor('screeningImages', language);
  const data = id ? images[id] : undefined;
  return { data, isLoading: false };
}
